// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDotsImg_root__jAPu6"};